<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component v-if="item.name === '3'" @addTab2="addTab2()" :is="item.content" :ref="item.ref" @addTab="addTab()" @removeTab="removeTab(item.name)" :updataID='updataID'></component>
      <component v-else :is="item.content" :ref="item.ref" @addTab="addTab()" @removeTab="removeTab(item.name)" :updataID='updataID'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import filters from '../../method/filter.js'
import QyzsAdd from '../../../../../static/form/xsyz/QyzsAdd.vue'
import QyzsRyzz from '../../../../../static/form/xsyz/QyzsRyzz.vue'
import QyzsTjqy from '../../../../../static/form/xsyz/QyzsTjqy.vue'
import QyzsZzlb from '../../assembly/xsyz/QyzsZzlb.vue'
import QyzsCplb from '../../assembly/xsyz/QyzsCplb.vue'
export default {
  mixins: [filters],
  components: {
    QyzsAdd,
    QyzsRyzz,
    QyzsTjqy,
    QyzsZzlb,
    QyzsCplb
  },
  data()
  {
    return {
      updataID: this.$route.query.id,
      editableTabsValue: '1',
      editableTabs: [{
        title: '公司信息',
        name: '1',
        closable: false,
        content: QyzsAdd
      },
      {
        title: '资质列表',
        name: '2',
        closable: false,
        content: QyzsZzlb
      },
      {
        title: '产品列表',
        name: '3',
        closable: false,
        content: QyzsCplb
      }],
      addobj: {
        title: '添加荣誉资质',
        name: `4`,
        closable: true,
        content: QyzsRyzz
      },
      addobj2: {
        title: '添加企业产品',
        name: `5`,
        closable: true,
        content: QyzsTjqy
      }
    }
  },
  methods: {
    handleClick(tab, event)
    {
      this.$router.push({path: '/QyzsUpdate'})
      this.$store.commit('onActiveName', tab.name)
    },
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    addTab2()
    {
      this.editableTabs.push(this.addobj2)
      this.editableTabsValue = this.addobj2.name
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/xsyzgl/QyzsUpdate.vue